import httpService from '../httpService';
import { PaginatedEventTicketStats } from '../../models/marketplace.model';

export async function getEventTicketStats(
  dashboardId: number,
  page = 1,
  perPage = 20,
  from?: Date,
  to?: Date,
): Promise<PaginatedEventTicketStats> {
  const params: any = { page, perPage };
  if (from) params.from = from.toISOString();
  if (to) params.to = to.toISOString();

  const response = await httpService.get(`/networks/dashboards/${dashboardId}/tickets/events`, {
    params,
  });

  return response.data;
}
